export type LoginData = {
  email: string;
  password: string;
};

export type LDInputErrors = {
  email: boolean;
  password: boolean;
};

export enum RouteName {
  AUTH_EMAIL = "auth-email",
  AUTH_PASSWORD = "auth-password",
  AUTH_EMAIL_FP = "auth-email-fp",
  AUTH_EMAIL_SENT = "auth-email-sent",
  AUTH_EMAIL_CONFIRM = "auth-email-confirm",
  AUTH_EMAIL_CONFIRMING = "auth-email-confirming",
  AUTH_SIGNUP_CONFIRMING = "auth-signup-confirming",
  AUTH_EMAIL_CHANGE = "auth-email-change",
  AUTH_PASS_NEW = "auth-password-new",
  AUTH_ERROR_CONFIRM = "error-confirm",
  AUTH_SUCCESS_CONFIRM = "success-confirm",
  AUTH_ERROR_MAGIC = "error-magic",
  AUTH_SIGNING_IN = "sign-in",
  AUTH_SIGN_IN_CONFIRM = "sign-in-confirm",
  MENU_MAIN = "",
  QUESTIONNAIRE_MAIN = "questionnaires",
  QUESTIONNAIRE_SUPPLEMENTS = "questionnaire-supplements",
  QUESTIONNAIRE_LIFESTYLE = "questionnaire-lifestyle",
  QUESTIONNAIRE_ONBOARDING_CHATBOT = "questionnaire-onboarding-chatbot",
  QUESTIONNAIRE_FIRSTCLASSES_REC = "questionnaire-firstclasses-rec",
  QUESTIONNAIRE_ALGORITHM = "questionnaire-algorithm",
  QUESTIONNAIRE_SHOPIFY = "questionnaire-shopify",
  BLOOD_CHECKUPS = "blood-checkups",
  BLOOD_PROGRESS = "blood-progress",
  SETTINGS_PROFILE = "profile",
  SETTINGS_BIONIQ = "bioniq-settings",
  SETTINGS_LOGOUT = "logout",
  OPEN_PAGE = "open-page",
  DOWNLOAD_MOBILE_APP = "download-mobile",
}
export enum RouteNameMenu {
  MENU_ANALYTICS = "analytics",
  MENU_FORMULA = "formula",
  MENU_SETTINGS = "settings",
  MENU_MESSAGES = "messages",
}

export const RouteDisplayNames: { [key in RouteNameMenu]: string } = {
  analytics: "NAVBAR.ANALYTICS",
  formula: "NAVBAR.FORMULA",
  settings: "NAVBAR.SETTINGS",
  messages: "NAVBAR.MESSAGES",
};

export enum RouteActions {
  UPLOAD_BLOOD_TEST = "upload-test-result",
}

export const allowedRoutesOnMobileBrowser = [
  RouteNameMenu.MENU_ANALYTICS,
  RouteNameMenu.MENU_FORMULA,
  RouteNameMenu.MENU_SETTINGS,
  RouteNameMenu.MENU_MESSAGES,
  RouteName.AUTH_EMAIL,
  RouteName.AUTH_PASSWORD,
  RouteName.AUTH_EMAIL_FP,
  RouteName.AUTH_EMAIL_SENT,
  RouteName.AUTH_EMAIL_CONFIRM,
  RouteName.AUTH_EMAIL_CONFIRMING,
  RouteName.AUTH_EMAIL_CHANGE,
  RouteName.AUTH_PASS_NEW,
  RouteName.AUTH_ERROR_CONFIRM,
  RouteName.AUTH_SUCCESS_CONFIRM,
  RouteName.AUTH_ERROR_MAGIC,
  RouteName.AUTH_SIGNING_IN,
  RouteName.AUTH_SIGN_IN_CONFIRM,
  RouteName.MENU_MAIN,
  RouteName.QUESTIONNAIRE_MAIN,
  RouteName.QUESTIONNAIRE_SUPPLEMENTS,
  RouteName.QUESTIONNAIRE_LIFESTYLE,
  RouteName.QUESTIONNAIRE_ONBOARDING_CHATBOT,
  RouteName.QUESTIONNAIRE_FIRSTCLASSES_REC,
  RouteName.QUESTIONNAIRE_ALGORITHM,
  RouteName.BLOOD_CHECKUPS,
  RouteName.BLOOD_PROGRESS,
  RouteName.SETTINGS_PROFILE,
  RouteName.SETTINGS_BIONIQ,
  RouteName.SETTINGS_LOGOUT,
  RouteName.OPEN_PAGE,
  RouteName.DOWNLOAD_MOBILE_APP,
];
